const compute = (num1, sign, num2) => {
  num1 = parseInt(num1);
  num2 = parseInt(num2);
  if (isNaN(num1)) return true;
    else if (sign === '===') return num2 === num1;
    else if (sign === '>') return num2 > num1;
    else if (sign === '<') return num2 < num1;
    else return false;
}

const Filter = {
  checkId: (id, cardId) => {
    return cardId === id;
  },
  checkType: (type, cardType) => {
    return type === 'all' || cardType === type ? true : false;
  },
  checkPack: (pack, cardPack) => {
    return pack === 'all' || cardPack === pack ? true : false;
  },
  checkRarity: (rarity, cardRarity) => {
    return rarity === 'all' || cardRarity === rarity ? true : false;
  },
  checkAlpha: (alpha, cardAlpha) => {
    if (alpha === 'all') return true;
    else if (alpha === 'non-alpha' && cardAlpha === undefined) return true;
    else if (alpha === 'alpha' && cardAlpha) return true;
    else return false;
  },
  checkName: (name, cardName) => {
    return cardName.toLowerCase().includes(name.toLowerCase());
  },
  checkRelease: (release, cardRelease) => {
    return release === 'all' || cardRelease === release ? true : false;
  },
  checkElement: (element, cardElement) => {
    return element === 'all' || cardElement === element ? true : false;
  },
  checkCategory: (category, cardCategory) => {
    return category === 'all' || cardCategory === category ? true : false;
  },
  checkHashtag: (tag, cardTags) => {
    if (tag === '') return true;
    let found = false;
    if (cardTags !== undefined){
      cardTags.forEach(cardTag => {
        if (cardTag.toLowerCase().includes(tag.replace('#','').toLowerCase())){
          found = true;
        }
      });
    }
    return found;
  },
  checkMp: (mp, sign, cardMp) => {
    return compute(mp, sign, cardMp)
  },
  checkShrine: (shrine, sign, cardShrine) => {
    return compute(shrine, sign, cardShrine)
  },
  checkAttack: (attack, sign, cardAttack) => {
    return compute(attack, sign, cardAttack)
  },
  checkDefense: (defense, sign, cardDefense) => {
    return compute(defense, sign, cardDefense)
  },
  checkText: (text, cardAbilities, cardSkills) => {
    if (text === '') return true;
    let found = false;
    if (cardAbilities !== undefined){
      cardAbilities.forEach(cardAbility => {
        if (cardAbility.toLowerCase().includes(text.toLowerCase())){
          found = true;
        }
      });
    }
    if (cardSkills !== undefined){
      cardSkills.forEach(cardSkill => {
        if (cardSkill.description.toLowerCase().includes(text.toLowerCase())){
          found = true;
        }
      });
    }
    return found;
  },
}

export default Filter;